module.exports = __webpack_public_path__ + "static/media/trimurti.8f9ba1ba.jpg";